import { useMemo, useRef } from 'react';
import Fuse from 'fuse.js';
import { shallowEqual, useSelector } from 'react-redux';

const searchOptions = {
  includeScore: true,
  keys: ['desc'],
};

function defaultSort(a, b) {
  if (a && a.user && a.user.name && b && b.user && b.user.name) {
    return a.user.name.localeCompare(b.user.name);
  }
  if (a && a.user && a.user.name) {
    return 1;
  }
  if (b && b.user && b.user.name) {
    return -1;
  }
  return 0;
}

function useFilterUserXJoon3s({ deviceId, filters, sortBy }) {
  const queryId = deviceId || 'default';
  const data = useSelector(
    (store) =>
      (store.userXJoon3s[queryId] &&
        Object.values(store.userXJoon3s[queryId])) ||
      [],
    shallowEqual,
  );
  const lastResult = useRef();
  const jsonFilters = JSON.stringify(filters);
  const filtered = useMemo(() => {
    let _data = data.filter((i) => i);
    if (filters && filters.search) {
      const fuse = new Fuse(_data, searchOptions);
      _data = fuse
        .search(filters.search)
        .sort((a, b) => a.score - b.score)
        .map((i) => i.item);
      lastResult.current = _data;
    } else {
      lastResult.current = _data;
    }
    if (sortBy) {
      return lastResult.current.sort(sortBy);
    }
    return lastResult.current.sort(defaultSort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonFilters, data, sortBy]);
  return filtered;
}

export default useFilterUserXJoon3s;
